import React from 'react';

const YachayAvatar: React.FC = () => (
  <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
    {/* You can replace this with an actual avatar image or SVG */}
    <span role="img" aria-label="Yachay Avatar" className="text-white text-lg">🧑‍⚕️</span>
  </div>
);

export default YachayAvatar;